import type { FieldProps } from '@atlassian/forge-ui-types';
import type { SelectProps } from '@atlaskit/select';

/**
 * Excluded props:
 * - innerProps - not supporting HTML attributes at this time
 * - parseInputValue - not supporting as it does not work, function can't be passed outside of runtime
 * - formatDisplayLabel - not supporting as it does not work, function can't be passed outside of runtime
 */

// Type copied from packages/design-system/datetime-picker/src/components/time-picker.tsx
type Appearance = 'default' | 'subtle' | 'none';
type Spacing = 'compact' | 'default';

export type TimePickerProps = {
	appearance?: Appearance;
	autoFocus?: boolean;
	defaultIsOpen?: boolean;
	defaultValue?: string;
	isOpen?: boolean;
	label?: string;
	onChange?: (value: string) => void;
	spacing?: Spacing;
	times?: string[];
	timeIsEditable?: boolean;
	value?: string;
	isInvalid?: boolean;
	hideIcon?: boolean;
	timeFormat?: string;
	placeholder?: string;
	locale?: string;
	testId?: string;
  selectProps?: SelectProps<any | false>;
} & Partial<Omit<FieldProps, 'onChange' | 'isRequired'>>;

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::f827999d4358165e25322a23434a0442>>
 * @codegenId #time-picker
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen time-picker
 * @codegenParams {  "defineOwnType": true, "hasFieldProps": { "value": false, "isRequired": false, "onChange": false}, "props": { "appearance": true, "autoFocus": true, "defaultIsOpen": true, "defaultValue": true, "formatDisplayLabel": false, "innerProps": false, "isOpen": true, "label": true, "parseInputValue": false, "spacing": true, "times": true, "timeIsEditable": true, "hideIcon": true, "timeFormat": true, "placeholder": true, "locale": true, "testId": true, "selectProps": true, "onChange": true, "value": {"replaceLine": true, "value": "{...(value !== undefined ? { value }: undefined) }", "comment": "Explicitly setting value to undefined is causing issues"} } }
 * @codegenDependency ../../../../../../../design-system/datetime-picker/src/components/time-picker.tsx <<SignedSource::f858b3b40b06c6c45956a022b3dd3c4f>>
 * @codegenDependency ../../../../../../../design-system/datetime-picker/src/types.tsx <<SignedSource::01e56ab6293a125750006fe63951c923>>
 * @codegenDependency ../../../../../../../analytics/analytics-next/src/hocs/withAnalyticsContext.tsx <<SignedSource::fe8cfa3b5df7c0625832b02a14245144>>
 * @codegenDependency ../../../../../../../design-system/datetime-picker/src/index.tsx <<SignedSource::ccce7ae2ef1a6f54ee790977cd70ce4b>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import type { RenderFn } from '@atlassian/forge-ui-types';
import { TimePicker as PlatformTimePicker } from '@atlaskit/datetime-picker';
import { adaptEventHandler } from "../../../utils";

// Define the type for TimePicker as TimePickerProps at the top of this file

export const TimePicker = (props: Parameters<RenderFn>[0]) => {
  const {
    appearance,
    autoFocus,
    defaultIsOpen,
    defaultValue,
    isOpen,
    label,
    selectProps,
    spacing,
    times,
    timeIsEditable,
    hideIcon,
    timeFormat,
    placeholder,
    locale,
    testId,
    onChange,
    value,
    // Field props
    id,
    isDisabled,
    isInvalid,
    onBlur,
    onFocus,
    "aria-invalid": ariaInvalid,
    "aria-labelledby": ariaLabelledby,
    name,
  } = props.forgeDoc.props as TimePickerProps;
  return (
    <PlatformTimePicker
      appearance={appearance}
      autoFocus={autoFocus}
      defaultIsOpen={defaultIsOpen}
      defaultValue={defaultValue}
      isOpen={isOpen}
      label={label}
      selectProps={selectProps}
      spacing={spacing}
      times={times}
      timeIsEditable={timeIsEditable}
      hideIcon={hideIcon}
      timeFormat={timeFormat}
      placeholder={placeholder}
      locale={locale}
      testId={testId}
      onChange={onChange}
      // Explicitly setting value to undefined is causing issues
      {...(value !== undefined ? { value }: undefined) }
      // Field props
      id={id}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      onBlur={adaptEventHandler(onBlur)}
      onFocus={adaptEventHandler(onFocus)}
      aria-invalid={ariaInvalid}
      aria-labelledby={ariaLabelledby}
      name={name}
    />
  );
};
/**
 * @codegenEnd
 */
